// Note: Pre cache in public/service-worker.js

import { IVideoPlayerProps } from '@components/VideoPlayer/VideoPlayer.types';

// eslint-disable-next-line import/prefer-default-export
export const GradientBackgroundVideoPlaySource: IVideoPlayerProps = {
  webpSrc: 'https://cdn.perksbar.com/perksbar-web/gradient_bg.webm',
  mp4Src: 'https://cdn.perksbar.com/perksbar-web/gradient_bg.mp4',
  poster: 'https://cdn.perksbar.com/perksbar-web/gradient_bg.jpg',
};
